import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { DependantType } from './dependant-type.interface';
import { DependantTypeService } from './dependant-type.service';
const service = new DependantTypeService();

export interface DependantTypeState {
   dependantTypes: Array<DependantType>;
}

const DependantTypeStore: Module<DependantTypeState, StoreState> = {
   namespaced: true,
   state: {
      dependantTypes: [],
   },
   getters: {},
   mutations: {
      SET_DEPENDANT_TYPES(state, dependantTypes: Array<DependantType>) {
         state.dependantTypes = dependantTypes;
      },
   },
   actions: {
      async getDependantTypes(context) {
         const response = await service.getDependantTypes();
         context.commit('SET_DEPENDANT_TYPES', response.data);
         return response.data;
      },
   },
};

export default DependantTypeStore;
